// extracted by mini-css-extract-plugin
export default {"mainWrapper":"PoolDrivers_mainWrapper__O4g2c","driverName":"PoolDrivers_driverName__GIbgA"};